import { Directive, HostListener, output } from '@angular/core';

@Directive({
	selector: '[vc-clicked]',
})
export class ClickedDirective {
	clicked = output<void>();

	@HostListener('click', ['$event'])
	onClick(event: Event) {
		event.stopPropagation();
		this.clicked.emit();
		return false;
	}
}
